module.exports = __webpack_public_path__ + "img/Katzenbabies.10908c72.svg";